import useRouter from 'app/hooks/useRouter';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { useHistory } from 'react-router';

export default function NotFoundPage() {
  const { lang } = getLocales();
  const router = useRouter();
  const _history = useHistory();
  return (
    <Page
      class={ThemePageError}
      header={<>{lang.pageNotFound}</>}
      render={
        <div style={{ fontSize: '5.4em' }}>
          <Icon class="fas-search" style={{ opacity: 0.5 }} /> 404
          <br />
          <Button
            class={ThemeButtonCircle}
            style={{ fontSize: Theme.FontSize.M, margin: `${Theme.Size.L} auto` }}
            active
            onClick={() => _history.push(router.homeRoute.path)}
          >
            {lang.goHome}
          </Button>
        </div>
      }
    />
  );
}
